<template>
	<view class="box">
		<view class="yue">
			<!-- <view class="yue-a">提现</view> -->
			<view class="yue-b">-¥{{(info.amount || 0).toFixed(2)}}</view>
			<view class="yue-c err"  v-if="info.status == 2">未通过</view>
			<view class="yue-c succ" v-else-if="info.status == 1">已通过</view>
			<view class="yue-c err" v-else>审批中</view>
		</view>
		<view class="info">
			<view class="info-item">
				<view class="info-item-label">提交时间</view>
				<view class="info-item-val">{{info.createDate ||''}}</view>
			</view>
			<view class="info-item">
				<view class="info-item-label">提现银行</view>
				<view class="info-item-val">{{info.bankName ||''}}</view>
			</view>
			<view class="info-item" v-if="info.status == 1 || info.status == 2">
				<view class="info-item-label">审核时间</view>
				<view class="info-item-val">{{info.auditTime ||''}}</view>
			</view>
			<view class="info-item" v-if="info.status == 1">
				<view class="info-item-label"> 打款银行</view>
				<view class="info-item-val">{{info.bankName ||''}}</view>
			</view>
			<view class="info-item"  v-if="info.status == 1 || info.status == 2">
				<view class="info-item-label">备注信息</view>
				<view class="info-item-val">{{info.auditRemark ||'-'}}</view>
			</view>
			<view class="info-item"v-if="info.status == 1 && info.payFileList && info.payFileList.length">
				<view class="info-item-label" >打款凭证</view>
				<view class="info-item-list">
					<view class="info-item-list-item" v-for="(item,index) in info.payFileList" :key="index" >
						<image :src="item.fileFullUrl?item.fileFullUrl:'/static/icon/default2.png'" mode="widthFix" @click="previewImage(index)"></image>
					</view>
					<view style="width: 120rpx; height: 0rpx;"></view>
					<view style="width: 120rpx; height: 0rpx;"></view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		computed: {
			...mapState(['navHeight', 'statusbarHeight','shopInfo', 'shopToken'])
		},
		data() {
			return { 
				id:null, 
				shop:{},
				info:{}
			};
		}, 
		onLoad(options) {
			this.id = options.id
			this.info={}
			this.shop  ={}
			this.checkShopLogin()
			this.shop = this.shopInfo || {} 
			this.getDataDetail()
		},
		methods:{ 
			previewImage (index)  {
				if (this.info.payFileList && this.info.payFileList.length) {
					var urls = this.info.payFileList.map((item)=>{return item.fileFullUrl })
					uni.previewImage({
						urls:urls,
						current:index ||0
					})
				}
			},
			async  getDataDetail(){
				var that =this 
				let res = await that.$u.api.withdrawDetail({id:this.id,tokenType:1  })
				if (res.code === 200) { 
					this.info = res.data 
				} 
			},
			checkShopLogin(){
				var that =this
				if( this.shopInfo ==null || this.shopInfo.id==null ||  this.shopToken==null || this.shopToken==''){
					uni.navigateTo({
						url: '/pages/login/login'
					})
				} 
			}
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.yue {
			width: 100%;
			height: 286rpx;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			background: #FFFFFF;
			.yue-a {
				font-weight: 400;
				font-size: 30rpx;
				color: #222222;
			}
			.yue-b {
				font-weight: 600;
				font-size: 48rpx;
				color: #222222;
				margin-top: 30rpx;
			}
			.succ {
				background: rgba(0,64,150,0.1) !important;
				color: #004096 !important;
			}
			.err {
				background: rgba(228,0,29,0.1);
				color: #E4001D;
			}
			.yue-c {
				width: 110rpx;
				height: 48rpx;
				line-height: 48rpx;
				text-align: center;
				border-radius: 8rpx;
				font-weight: 400;
				font-size: 26rpx;
				margin-top: 20rpx;
			}
		}
		.info {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			margin-top: 20rpx;
			display: flex;
			flex-direction: column;
			.info-item {
				width: 100%;
				display: flex;
				align-items: flex-start;
				margin-bottom: 30rpx;
				&:last-child {
					margin: 0 !important;
				}
				.info-item-label {
					flex-shrink: 0;
					font-weight: 400;
					font-size: 28rpx;
					color: #666666;
					margin-right: 40rpx;
				}
				.info-item-val {
					flex: 1;
					font-weight: 400;
					font-size: 28rpx;
					color: #222222;
				}
				.info-item-list {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;
					flex-wrap: wrap;
					.info-item-list-item {
						width: 120rpx;
						height: 120rpx;
						border-radius: 8rpx;
						image {
							width: 100%;
						}
					}
				}
			}
		}
	}
</style>